module.exports = __webpack_public_path__ + "static/img/thum-global.4b3f84d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/thum-global.png
// module id = eK/A
// module chunks = 134